const { same } = require('../utils');

exports.computeSkewXFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'skewX');
exports.computeSkewYFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'skewY');
